import React, { useRef, useState, useCallback } from "react"
import YoutubePlayer from "react-player/youtube"

const SPEED_OPTIONS = [0.5, 1, 1.5, 2]

const PlayIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M8 5v14l11-7z"/>
  </svg>
)

const PauseIcon = () => (
  <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
    <path d="M6 19h4V5H6v14zm8-14v14h4V5h-4z"/>
  </svg>
)

const RewindIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
    <path d="M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z"/>
  </svg>
)

const ForwardIcon = () => (
  <svg viewBox="0 0 24 24" className="w-5 h-5 fill-current">
    <path d="M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z"/>
  </svg>
)

export const RepoructorVideo = ({ video, videoViewed = () => {}, videoPaused = () => {}, onReady = () => {} }) => {
  const playerRef = useRef(null)
  const [playing, setPlaying] = useState(false)
  const [playbackRate, setPlaybackRate] = useState(1)
  const [showSpeedMenu, setShowSpeedMenu] = useState(false)

  const handlePlayPause = () => {
    setPlaying(prev => !prev)
  }

  const handleRewind = () => {
    if (playerRef.current) {
      const currentTime = playerRef.current.getCurrentTime()
      playerRef.current.seekTo(Math.max(0, currentTime - 10))
    }
  }

  const handleForward = () => {
    if (playerRef.current) {
      const currentTime = playerRef.current.getCurrentTime()
      playerRef.current.seekTo(currentTime + 10)
    }
  }

  const handleSpeedChange = (rate) => {
    setPlaybackRate(rate)
    setShowSpeedMenu(false)
  }

  const handleEnded = useCallback(() => {
    setPlaying(false)
    videoViewed()
  }, [videoViewed])

  const handlePause = useCallback(() => {
    setPlaying(false)
    videoPaused()
  }, [videoPaused])

  const handlePlay = useCallback(() => {
    setPlaying(true)
  }, [])

  const handleReady = useCallback(() => {
    onReady()
  }, [onReady])

  return (
    <div className="relative w-full aspect-video">
      <YoutubePlayer
        ref={playerRef}
        playing={playing}
        playbackRate={playbackRate}
        url={video}
        width={'100%'}
        style={{
          objectFit: 'contain',
          padding: 1,
          zIndex: 0
        }}
        muted={false}
        controls={false}
        progressInterval={1000}
        onProgress={() => {}}
        onEnded={handleEnded}
        onPause={handlePause}
        onPlay={handlePlay}
        onReady={handleReady}
      />
      <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent px-4 py-3 flex items-center justify-center gap-3">
        <button
          onClick={handleRewind}
          className="text-white hover:text-primary transition-colors p-1"
          title="Retroceder 10s"
        >
          <RewindIcon />
        </button>
        <button
          onClick={handlePlayPause}
          className="text-white hover:text-primary transition-colors p-1"
          title={playing ? "Pausar" : "Reproducir"}
        >
          {playing ? <PauseIcon /> : <PlayIcon />}
        </button>
        <button
          onClick={handleForward}
          className="text-white hover:text-primary transition-colors p-1"
          title="Avanzar 10s"
        >
          <ForwardIcon />
        </button>
        <div className="relative ml-2">
          <button
            onClick={() => setShowSpeedMenu(prev => !prev)}
            className="text-white hover:text-primary transition-colors text-sm font-semibold px-2 py-1"
            title="Velocidad"
          >
            {playbackRate}x
          </button>
          {showSpeedMenu && (
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 bg-white rounded-lg shadow-lg py-1 min-w-[64px]">
              {SPEED_OPTIONS.map(rate => (
                <button
                  key={rate}
                  onClick={() => handleSpeedChange(rate)}
                  className={`block w-full text-center px-3 py-1.5 text-sm whitespace-nowrap hover:bg-gray-100 transition-colors ${rate === playbackRate ? 'font-bold text-primary' : 'text-gray-700'}`}
                >
                  {rate}x
                </button>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
